import { ICriteria } from "src/app/core/services/criteria.interface";
import { HttpParams } from "@angular/common/http";
import * as moment from 'moment';

export class LiftErrorCriteria implements ICriteria {
  pageSize: number = 10;
  page: number = 1;
  orderby: string = 'CreatedAt desc';
  dateFrom: Date = null;
  dateTo: Date = null;
  code: string = null;

  paramsExport(): HttpParams {
    let filterCondition = '';
    let params = new HttpParams()
      .set('page', String(this.page))
      .set('orderby', this.orderby)
      .set('pageSize', String(this.pageSize));

    if (this.code) {
      filterCondition += 'Code.Contains("' + this.code + '")';
    }

    if (this.dateFrom) {
      filterCondition += (filterCondition) ? ' and ' : '';
      filterCondition += 'CreatedAt>=DateTime(' + moment(this.dateFrom).format('YYYY, MM, DD') + ')';
    }

    if (this.dateTo) {
      filterCondition += (filterCondition) ? ' and ' : '';
      filterCondition += 'CreatedAt<=DateTime(' + moment(this.dateTo).format('YYYY, MM, DD') + ')';
    }

    if (filterCondition) {
      params = params.set('filter', filterCondition);
    }

    return params;
  }
}
